import { render, staticRenderFns } from "./HistoryManageDialog.vue?vue&type=template&id=9b733c5c&scoped=true"
import script from "./HistoryManageDialog.vue?vue&type=script&lang=ts"
export * from "./HistoryManageDialog.vue?vue&type=script&lang=ts"
import style0 from "./HistoryManageDialog.vue?vue&type=style&index=0&id=9b733c5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b733c5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b733c5c')) {
      api.createRecord('9b733c5c', component.options)
    } else {
      api.reload('9b733c5c', component.options)
    }
    module.hot.accept("./HistoryManageDialog.vue?vue&type=template&id=9b733c5c&scoped=true", function () {
      api.rerender('9b733c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/HistoryManageDialog.vue"
export default component.exports